import { useTranslation } from "react-i18next";

import { AnalyzeLoader } from "#modules/quoteRequestLines/AnalyzeLoader";
import { Flex } from "#shared/view/components/Flex";

export const PredictingState = () => {
  const { t } = useTranslation();

  return (
    <Flex justify={"end"} align={"center"} h={"100%"}>
      <AnalyzeLoader text={`${t("qrl.price.estimating")}...`} />
    </Flex>
  );
};
